import React, { Component } from 'react'

import { translation } from '../../../../utils/helpers'
import { CapacityManagementIcons } from '../../../elements/icons'

import CloseButton from '../../../elements/closeButton'
import Grid from '../../../elements/grid'
import Inline from '../../../elements/inline'
import Circle from '../../../elements/circle'
import ProgressLine from '../../../elements/progressLine'
import Icon from '../../../elements/icon'

import './infoBar.scss'
import CircleButton from '../../../elements/circleButton'

class InfoBar extends Component {
  constructor (props) {
    super(props)

    this.state = {
    }
  }

  render () {
    return (
      <div className='capacity-calendar-info-bar'>
        <Grid cols={[ 1, 'min-content' ]} align='center'>
          <div className='capacity-calendar-info-bar__icons'>
            <Inline spacing={0}>
              <Circle size='t' color='brand-2' />
              <span className='capacity-calendar-info-bar__label'>{translation('17897')}</span>
            </Inline>
            <Inline spacing={0}>
              <ProgressLine />
              <span className='capacity-calendar-info-bar__label'>{translation('16600')}</span>
            </Inline>
            <Inline spacing={0}>
              <ProgressLine color='yellow' />
              <span className='capacity-calendar-info-bar__label'>{translation('18332')}</span>
            </Inline>
            <Inline spacing={0}>
              <ProgressLine color='red' />
              <span className='capacity-calendar-info-bar__label'>{translation('17898')}</span>
            </Inline>
            <Inline spacing={0}>
              <CircleButton size='s' icon={CapacityManagementIcons.Calendar} />
              <span className='capacity-calendar-info-bar__label'>{translation('18299')}</span>
            </Inline>
            <Inline spacing={0}>
              <CircleButton size='s' icon={CapacityManagementIcons.List_View} />
              <span className='capacity-calendar-info-bar__label'>{translation('18300')}</span>
            </Inline>
            <Inline spacing={0}>
              <CircleButton size='s' icon={CapacityManagementIcons.Assign} />
              <span className='capacity-calendar-info-bar__label'>{translation('1856')}</span>
            </Inline>
            <Inline spacing={0}>
              <Icon icon={CapacityManagementIcons.Warning_attention_white} size='s' injectSvg />
              <span className='capacity-calendar-info-bar__label'>{translation('18301')}</span>
            </Inline>
            <Inline spacing={0}>
              <Icon icon={CapacityManagementIcons.Warning_Order_stop} size='s' injectSvg />
              <span className='capacity-calendar-info-bar__label'>{translation('18302')}</span>
            </Inline>
            <Inline spacing={0}>
              <Icon icon={CapacityManagementIcons.Warning_spare_part} size='s' injectSvg />
              <span className='capacity-calendar-info-bar__label'>{translation('18303')}</span>
            </Inline>
            <Inline spacing={0}>
              <Icon icon={CapacityManagementIcons.Warning_delayed} size='s' injectSvg />
              <span className='capacity-calendar-info-bar__label'>{translation('18304')}</span>
            </Inline>
            <Inline spacing={0}>
              <Icon icon={CapacityManagementIcons.warning_painter} size='s' injectSvg />
              <span className='capacity-calendar-info-bar__label'>{translation('18305')}</span>
            </Inline>
            <Inline spacing={0}>
              <Icon icon={CapacityManagementIcons.Warning_assign} size='s' injectSvg />
              <span className='capacity-calendar-info-bar__label'>{translation('18306')}</span>
            </Inline>
          </div>
          <CloseButton size='s' spacing={0} ariaLabel={translation('394')} onClick={this.props.onClose} />
        </Grid>
      </div>
    )
  }
}

export default InfoBar



// WEBPACK FOOTER //
// ./src/app/shared/overlays/OrderCapacityOverview/infoBar/index.js